/**
 * Firma tipi renkleri — TEK KAYNAK (#215).
 *
 * Panelin her yerinde (dashboard, firma listesi/ağacı/detayı, cihaz ve
 * kullanıcı detayı, firma oluşturma, raporlar, firma seçici) firma tipi rozet,
 * ikon, ikon kutusu ve grup tonu buradan gelir. Aile başına tek Tailwind rengi:
 *
 *   Depo     → purple      Bayi      → blue
 *   Müşteri  → teal
 *   Ana Bayi → amber (alt bayisi olan bayi)
 *
 * Müşteri bilerek GRİ DEĞİL (kullanıcı kararı 2026-10-13); teal, kullanıcı rol
 * rozetlerindeki müşteri rengiyle de aynı (utils/roleBadge.js).
 *
 * Sınıflar Tailwind JIT için TAM METİN yazılır — birleştirilmiş string üretilmez.
 */

export const FIRM_TYPE_STYLES = {
  storage: {
    label: "Depo",
    badge: "bg-purple-50 text-purple-700 border-purple-200",
    chip: "bg-purple-50 text-purple-700",
    icon: "text-purple-600",
    text: "text-purple-700",
    iconBox: "bg-purple-50 text-purple-600 border-purple-100",
    iconBoxHover: "group-hover:bg-purple-100 group-hover:border-purple-300",
    groupHead: "bg-purple-50/80",
    groupBody: "bg-purple-50/40",
    groupRail: "border-l-purple-400",
    groupRailBar: "bg-purple-400",
  },
  dealer: {
    label: "Bayi",
    badge: "bg-blue-50 text-blue-700 border-blue-200",
    chip: "bg-blue-50 text-blue-700",
    icon: "text-blue-600",
    text: "text-blue-700",
    iconBox: "bg-blue-50 text-blue-600 border-blue-100",
    iconBoxHover: "group-hover:bg-blue-100 group-hover:border-blue-300",
    groupHead: "bg-blue-50/80",
    groupBody: "bg-blue-50/40",
    groupRail: "border-l-blue-400",
    groupRailBar: "bg-blue-400",
  },
  mainDealer: {
    label: "Ana Bayi",
    badge: "bg-amber-50 text-amber-700 border-amber-200",
    chip: "bg-amber-50 text-amber-700",
    icon: "text-amber-600",
    text: "text-amber-700",
    iconBox: "bg-amber-50 text-amber-600 border-amber-100",
    iconBoxHover: "group-hover:bg-amber-100 group-hover:border-amber-300",
    groupHead: "bg-amber-50/80",
    groupBody: "bg-amber-50/40",
    groupRail: "border-l-amber-400",
    groupRailBar: "bg-amber-400",
  },
  customer: {
    label: "Müşteri",
    badge: "bg-teal-50 text-teal-700 border-teal-200",
    chip: "bg-teal-50 text-teal-700",
    icon: "text-teal-600",
    text: "text-teal-700",
    iconBox: "bg-teal-50 text-teal-600 border-teal-100",
    iconBoxHover: "group-hover:bg-teal-100 group-hover:border-teal-300",
    groupHead: "bg-teal-50/80",
    groupBody: "bg-teal-50/40",
    groupRail: "border-l-teal-400",
    groupRailBar: "bg-teal-400",
  },
};

/**
 * Firma (ya da ham tip string'i) → stil anahtarı. Bilinmeyen / boş tip müşteri
 * sayılır (sunucuda varsayılan firma tipi müşteridir).
 * @param {object|string} firmOrType
 * @param {{ mainDealer?: boolean }} [opts] - alt bayisi olan bayi için "Ana Bayi"
 */
export function getFirmTypeKey(firmOrType, { mainDealer = false } = {}) {
  const type = typeof firmOrType === "string" ? firmOrType : firmOrType?.firmType;
  if (type === "storage") return "storage";
  if (type === "dealer") return mainDealer ? "mainDealer" : "dealer";
  return "customer";
}

/** @returns {typeof FIRM_TYPE_STYLES.customer} */
export function getFirmTypeStyle(firmOrType, opts) {
  return FIRM_TYPE_STYLES[getFirmTypeKey(firmOrType, opts)];
}

/**
 * Raporların "Ana Firma" sütunu (#255): üst firma bayiyse adın yanına
 * "(Bayi)". Excel düz metin olduğu için renksiz; PDF'te sunucu mavi basar.
 * @param {string|null|undefined} name - üst firma adı
 * @param {string|null|undefined} type - üst firmanın firmType'ı (mainFirmType)
 * @param {string} [empty="-"] - üst firma yoksa
 */
export function parentFirmLabel(name, type, empty = "-") {
  if (!name || name === "-") return empty;
  return type === "dealer" ? `${name} (${FIRM_TYPE_STYLES.dealer.label})` : name;
}
